import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {NgbActiveModal, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {CustomValidators} from '../../core/validator/custom-validators';
import {ValidatorService} from '../../core/validator/validator.service';
import {WorkTimeRangeModel} from '../time-tracker/time-tracker-model/work-time-range.model';
import {CreateWorkTimeRangeModel} from '../time-tracker/time-tracker-model/create-work-time-range.model';
import {EditWorkTimeRangeModel} from '../time-tracker/time-tracker-model/edit-work-time-range.model';
import {DeleteWorkTimeRangeModel} from '../time-tracker/time-tracker-model/delete-work-time-range.model';
import {DialogService} from '../../dialog/dialog.service';
import TimeTrackerUtils from '../time-tracker/time-tracker-utils';


@Component({
  selector: 'app-dialog-work-time-range',
  templateUrl: './dialog.work-time-range.component.html'
})
export class DialogWorkTimeRangeComponent implements OnInit {
  hidden: boolean;
  readOnly: boolean;
  newWorkTimeRangeFlag: boolean;

  timeForm: FormGroup;
  workTimeRangeDetailsForm: FormGroup;

  MINUTE_STEP = 10;

  fromTime: NgbTimeStruct = {hour: 8, minute: 0, second: 0};
  toTime: NgbTimeStruct = {hour: 16, minute: 0, second: 0};
  formDescription: string;

  workDayId: number;
  workDayDate: Date;
  currentWorkTimeRange: WorkTimeRangeModel;
  newWorkTimeRange: CreateWorkTimeRangeModel = new CreateWorkTimeRangeModel();
  editWorkTimeRange: EditWorkTimeRangeModel = new EditWorkTimeRangeModel();
  deleteWorkTimeRange: DeleteWorkTimeRangeModel = new DeleteWorkTimeRangeModel();

  dialogService: DialogService;

  @Output() addWorkTimeRangeEvent = new EventEmitter<CreateWorkTimeRangeModel>();
  @Output() updateWorkTimeRangeEvent = new EventEmitter<EditWorkTimeRangeModel>();
  @Output() deleteWorkTimeRangeEvent = new EventEmitter<DeleteWorkTimeRangeModel>();

  constructor(public activeModal: NgbActiveModal,
              private validatorService: ValidatorService,
              private injector: Injector) {
    setTimeout(() => this.dialogService = injector.get(DialogService));
  }

  ngOnInit() {
    this.hidden = false;
    this.createWorkTimeRangeForm();
    if (!this.newWorkTimeRangeFlag) {
      this.fillFormData();
    }
  }

  private createWorkTimeRangeForm(): void {
    this.timeForm = new FormGroup({
      'fromTime': new FormControl('', Validators.required),
      'toTime': new FormControl('', Validators.required)
    }, CustomValidators.validateNgbTimeStructDates('fromTime', 'toTime'));
    this.workTimeRangeDetailsForm = new FormGroup({
      'description': new FormControl('', {validators: CustomValidators.notEmpty, updateOn: 'blur'}),
      'date': this.timeForm
    });
  }

  private fillFormData(): void {
    this.fromTime.hour = new Date(this.currentWorkTimeRange.startTime).getUTCHours();
    this.fromTime.minute = new Date(this.currentWorkTimeRange.startTime).getUTCMinutes();
    this.toTime.hour = new Date(this.currentWorkTimeRange.stopTime).getUTCHours();
    this.toTime.minute = new Date(this.currentWorkTimeRange.stopTime).getUTCMinutes();
    this.formDescription = this.currentWorkTimeRange.reportedTimes[0].description;
  }

  onUpdate() {
    if (this.validatorService.isValidFormGroup(this.workTimeRangeDetailsForm)) {
      this.initEditWorkTimeRange();
      this.updateWorkTimeRangeEvent.emit(this.editWorkTimeRange);
      this.activeModal.close(true);
    }
  }

  private initEditWorkTimeRange() {
    this.editWorkTimeRange.workTimeRangeId = this.currentWorkTimeRange.id;
    this.editWorkTimeRange.startTime = TimeTrackerUtils.obtainDateFromDateAndNgbTimeStruct(this.workDayDate, this.fromTime);
    this.editWorkTimeRange.stopTime = TimeTrackerUtils.obtainDateFromDateAndNgbTimeStruct(this.workDayDate, this.toTime);
    this.editWorkTimeRange.description = this.formDescription;
  }

  onAdd() {
    if (this.validatorService.isValidFormGroup(this.workTimeRangeDetailsForm)) {
      this.initNewWorkTimeRange();
      this.addWorkTimeRangeEvent.emit(this.newWorkTimeRange);
      this.activeModal.close(true);
    }
  }

  private initNewWorkTimeRange() {
    this.newWorkTimeRange.workDayId = this.workDayId;
    this.newWorkTimeRange.startTime = TimeTrackerUtils.obtainDateFromDateAndNgbTimeStruct(this.workDayDate, this.fromTime);
    this.newWorkTimeRange.stopTime = TimeTrackerUtils.obtainDateFromDateAndNgbTimeStruct(this.workDayDate, this.toTime);
    this.newWorkTimeRange.description = this.formDescription;
  }

  openWorkTimeRangeDeleteModal() {
    this.hideComponent();
    this.dialogService.openWorkTimeRangeDeleteModal(this.currentWorkTimeRange, this);
  }

  deleteWorkTimeRangeWithReason(reason: string) {
    this.initDeleteWorkTimeRangeWithReason(reason);
    this.deleteWorkTimeRangeEvent.emit(this.deleteWorkTimeRange);
    this.activeModal.close(true);
  }

  private initDeleteWorkTimeRangeWithReason(reason: string) {
    this.deleteWorkTimeRange.workTimeRangeId = this.currentWorkTimeRange.id;
    this.deleteWorkTimeRange.reason = reason;
  }

  showComponent() {
    this.hidden = false;
  }

  hideComponent() {
    this.hidden = true;
  }

  onClose() {
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/dialog/dialog.work-time-range.component.ts